import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { schoolInfoCrudStateConfig } from "../consts";

export const {
  fetchActionFactory: fetchSchoolInfoActionFactory,
  updateActionFactory: updateSchoolInfoActionFactory
} = makeCrudStateActionFactories(schoolInfoCrudStateConfig);
